import React from 'react';
import { Switch as TeaSwitch } from 'tea-component';
import { IBasicFormItemProps } from '../../type';

export default function Switch(props: IBasicFormItemProps) {
  const { value, field, onChange } = props;

  return (
    <TeaSwitch
      value={value}
      onChange={(value: boolean) => {
        onChange(field, value);
      }}
    />
  );
};
